module.exports = __webpack_public_path__ + "static/media/wind.98264bb8.svg";